/**
 * Guard against the well-known white-screen crash that happens when a browser
 * translation feature (Google Translate / Safari Translate) rewrites the DOM
 * text nodes while React is reconciling. The translator wraps text in <font>
 * tags, so when React later tries to removeChild / insertBefore on the original
 * node it throws a NotFoundError and the whole app unmounts (blank page).
 *
 * This is the workaround recommended in the React issue tracker (#11538):
 * make removeChild / insertBefore no-throw when the node isn't a real child.
 */
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (typeof console !== 'undefined') {
        console.warn('translateGuard: skipped removeChild on a node moved by the translator');
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (typeof console !== 'undefined') {
        console.warn('translateGuard: skipped insertBefore for a node moved by the translator');
      }
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
